import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileChartColumn } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from '../architecture/frontend/index'
import _ from 'lodash'
import loadingSvg from '../../media/loading.svg'
import * as pbi from 'powerbi-client';

const Report = (props) => {
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='f6 white' icon={faFileChartColumn} />
          <div className='pl2 fw7 f6 white'>Power BI Reports</div>
          <div className='h2'></div>
        </div>
      </div>
      <div className='pt3'>
        <div className={' ' + (_.isNil(props.view.selectedReport) ? 'dib' : 'dn')}>
          <div className='flex '>
            {_.isNil(props.reports) ?
              <div>
                <img className='w4' src={loadingSvg} alt='loading'></img>
              </div>
              :
              props.reports.map(report => 
                <div className="mr3 mv3 pa3 h4 w4 br3 white flex justify-center items-center tc f6 fw7 flex-column pointer" style={{backgroundColor: "#b151a2"}} onClick={e => {
                  
                  const embedContainer = document.getElementById(report.id)
                  let embedConfiguration = {
                    type: 'report',
                    id: report.id,
                    embedUrl: report.embedURL,
                    tokenType: pbi.models.TokenType.Embed,
                    accessToken: report.token,
                    settings: {
                      customLayout: {
                        displayOption: pbi.models.DisplayOption.FitToPage
                      }
                    }
                  };
                  window.powerbi.embed(embedContainer, embedConfiguration);
                  Dispatch.mergeState('view', { selectedReport: report.id })
                }}>
                  <div className="pb2"><FontAwesomeIcon className='f3 white' icon={faFileChartColumn} /></div>
                  {report.name}
                </div>
              )
            }
           </div>
          </div>
          {
            // Power BI won't embed into the same div ID without DOM reload. We create a div for each report ID to get around this problem.
            !_.isNil(props.reports) && props.reports?.map(report => 
              <div className={'w-100 pt3 ' + (props.view.selectedReport === report.id ? 'dib' : 'dn') } style={{height:props.ui.window.height - 135}} id={report.id}>{report.id}</div>
            )
          }
      </div>
    </div>
  )
}

export default Report